import React from "react";
import { useHistory } from "react-router";

import MainContent from "/component/layout/MainContent";
import routes from "/constant/url.constant";

import { Props } from "./AvailabilitiesBackButton.types";

/**
 * This special back button will attempt to go back when `canGoBack` is true, and there is a route
 * to go back to, otherwise it will redirect to `scheduling`.
 *
 * You cannot go back to Decision Support from the Availabiltiies screens.
 */
const AvailabilitiesBackButton = ({ canGoBack }: Props) => {
  const history = useHistory();

  const goBack = history.action === "PUSH" && canGoBack;
  const handleBack = () => {
    if (goBack) {
      history.goBack();
    } else {
      history.push(routes.scheduling);
    }
  };

  return <MainContent.BackButton onClick={handleBack} icon={goBack ? "back" : "close"} />;
};

export default AvailabilitiesBackButton;
